import {Component, inject, input, OnInit, signal, ViewEncapsulation} from '@angular/core'
import {AdminService} from '../../services/admin.service'
import {DomSanitizer, SafeHtml} from '@angular/platform-browser'

@Component({
  selector: 'spb-ucreport',
  templateUrl: './ucreport.component.html',
  styleUrls: ['./ucreport.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class UcreportComponent implements OnInit {
  /**
   * All we need is love, or a personnummer in this case.
   */
  public personnummer = input<string | undefined>(undefined)
  /**
   * The data to show inside the inner html.
   */
  public htmlData = signal<SafeHtml>('')

  private readonly adminService = inject(AdminService)

  private readonly sanitizer = inject(DomSanitizer)

  public ngOnInit(): void {
    this.adminService.getUcReport(this.personnummer()).subscribe(res => {
      this.htmlData.set(this.sanitizer.bypassSecurityTrustHtml(res.report))
    })
  }
}